import { gql } from '@apollo/client';

const LAST_EVALUATION_EVENT_FRAGMENT = gql`
  fragment LastEvaluationEventFragment on EcgEvent {
    id
    createdAt
    start
    stripImgs
  }
`;

export default LAST_EVALUATION_EVENT_FRAGMENT;
